import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PeopleProfileShowDetailsModalComponent } from './people-profile-show-details-modal.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [PeopleProfileShowDetailsModalComponent],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class PeopleProfileShowDetailsModalModule { }
